



























































































import Vue from 'vue'
import LandingWidget from '@/views/LandingWidget.vue'
import ProgressIndicator from '@/views/treatment/ProgressIndicator.vue'
import Appointments from '@/views/treatment/Appointments.vue'
import ExclusionGuard from '@/views/exclusion/ExclusionGuard.vue'
import NewMessagesWidget from '@/views/NewMessagesWidget.vue'

import { NotNull, Unpacked } from '@/utils'
import { CasesConnection } from '@/graphql-schema'
type Case = Unpacked<CasesConnection['nodes']>
type Patient = Case['patient']

export default Vue.extend({
  components: {
    Appointments,
    ExclusionGuard,
    LandingWidget,
    NewMessagesWidget,
    ProgressIndicator,
  },
  computed: {
    currentCase(): Case {
      return this.$store.getters.currentCase
    },
    patient(): Patient {
      return this.currentCase!.patient
    },
    username(): string | null | undefined {
      return this.patient!.alias
    },
  },
})
